<template>
  <Modal
    v-model="_value"
    width="500"
    title="JT808设置最小休息时间"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <Form :model="reqParams" :label-width="80">
      <FormItem prop="terminalNum" label="主机号">
        <Input v-model="reqParams.terminalNum" placeholder="请输入主机号">
        </Input>
      </FormItem>
      <FormItem prop="terminalNum" label="主机号列表">
        <Input v-model="reqParams.terminalNums" placeholder="请输入主机号列表">
        </Input>
      </FormItem>
      <FormItem prop="minRestingTime" label="最小休息时间">
        <Input v-model="reqParams.minRestingTime" placeholder="请输入最小休息时间">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'jt808setminrestingtimemodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        reqParams: {
          terminalNums:[],
          terminalNum:'',
          minRestingTime:0
        }
      }
    },
    methods: {
      ...mapActions([
        'NetCommandServ_SetMinRestingTime',
        'NetCommandServ_BatchSetMinRestingTime',
      ]),
      onOk() {
        if (Array.isArray(this._initValue)){
          store.dispatch('NetCommandServ_BatchSetMinRestingTime', {
            params: this.reqParams
          }).then(() => {
            this.$Message.success('发送成功')
          }).catch(err => {
            this.$Message.error(err)
          })
        }else {
          store.dispatch('NetCommandServ_SetMinRestingTime', {
            params: this.reqParams
          }).then(() => {
            this.$Message.success('发送成功')
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      },
      visibleChange(val) {
        if(val){
          if (Array.isArray(this._initValue)){
            this.reqParams.terminalNums = this._initValue
          } else {
            this.reqParams.terminalNum = this._initValue
          }
          this.reqParams.minRestingTime = 14400
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
